module.exports = __webpack_public_path__ + "static/media/pres12.e656357c.png";